import DOMPurify from "isomorphic-dompurify"

import Style from "@/components/Bundles/StaticBundle/BundlesHighlights/index.module.scss"

const BundleHighlights = props => {
  const { features } = props

  return (
    <div
      className={Style.BundleHighlights}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(features),
      }}
    />
  )
}

export default BundleHighlights
